import { Box, Dialog, Typography, IconButton, useTheme } from '@mui/material'
import { FC, useEffect, useState } from 'react'
import Geocode from 'react-geocode'
import { Icon } from 'packages/eid-icons'
import GoogleMapReact from 'google-map-react'
import config from 'config'
import { Tooltip } from 'packages/eid-ui'
const mobileScreenWidth = '767px'

export interface ComputerSessionRequestDetailsProps {
    latitude: number
    langitutde: number
    onClose: () => void
    title: string
    open: boolean
}

export const ComputerMapDialog: FC<ComputerSessionRequestDetailsProps> = (
    props,
) => {
    const { open, onClose, title, latitude, langitutde } = props
    const [locationInfo, setLocationInfo] = useState('')
    const [center, setCenter] = useState({ lat: latitude, lng: langitutde })
    const theme = useTheme()
    const MyMapMarker = (lat: any, lng: any) => {
        return (
            <Box>
                <Tooltip title={locationInfo}>
                    <Box>
                        <Icon name="MapMarker" />
                    </Box>
                </Tooltip>
            </Box>
        )
    }

    useEffect(() => {
        if (latitude && langitutde) {
            setCenter({ lat: latitude, lng: langitutde })
            getLocationInfo()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [latitude, langitutde])

    const getLocationInfo = () => {
        try {
            const lat = latitude.toString()
            const lang = langitutde.toString()
            Geocode.setApiKey(config.GOOGLE_MAP_API_KEY)
            Geocode.setLanguage('en')
            Geocode.fromLatLng(lat, lang).then(
                (response) => {
                    setLocationInfo(response.results[0].formatted_address)
                },
                (error) => {
                    console.error(error)
                },
            )
        } catch (err) {}
    }

    return (
        <Dialog
            scroll={'body'}
            open={open}
            onClose={onClose}
            aria-labelledby={title}
            aria-describedby={title}
            PaperProps={{
                sx: {
                    maxWidth: '1000px',
                    width: '840px',
                    [`@media (max-width:${mobileScreenWidth})`]: {
                        margin: '8px ',
                        width: 'calc(100% - 16px) !important',
                        maxWidth: 'calc(100% - 16px) !important ',
                    },
                },
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    height: '80px',
                    alignItems: 'center',
                    padding: '16px 12px 16px 32px',
                    backgroundColor: theme?.palette?.background?.paper,
                }}
            >
                <Typography
                    sx={{
                        fontSize: '18px',
                        fontWeight: 'bold',
                        color: '#3b454d',
                    }}
                >
                    {title ? title : '---'}
                </Typography>

                <Box
                    sx={{
                        display: 'flex',
                    }}
                >
                    <IconButton onClick={onClose} size="large">
                        <Icon name="Close" color="#959598" />
                    </IconButton>
                </Box>
            </Box>
            <Box
                sx={{
                    backgroundColor: '#fbfbfd',
                    padding: '24px 40px',
                    boxShadow: '0 2px 16px 0 rgba(0, 0, 0, 0.11)',

                    '&:focus': {
                        outline: 'none',
                    },
                    height: '500px',
                }}
            >
                <GoogleMapReact
                    bootstrapURLKeys={{ key: config.GOOGLE_MAP_API_KEY }}
                    defaultCenter={center}
                    defaultZoom={15}
                >
                    <MyMapMarker lat={latitude} lng={langitutde} />
                </GoogleMapReact>
            </Box>
        </Dialog>
    )
}

export default ComputerMapDialog
